import styled, {css} from "styled-components";
import {JACKPOT_WIDGET_LAYOUT} from "../../jackpot-widget.component";
import {IJackpotWidgetLogoBoxProps} from "./jackpot-widget-logo.box";

export const JackpotWidgetLogoDefaultBox = styled.img<IJackpotWidgetLogoBoxProps>`
    /* In a widget of 468px wide, logo should be 222px wide */
    width: 47.436%;
    margin: 0rem auto;
    display: block;
    
    ${({layout}) => layout === JACKPOT_WIDGET_LAYOUT.PORTRAIT && css`
	    width: 78%;
	    padding-top: 1rem;

        @media ${({theme}) => theme.mediaQuery.mAndBelow} {
            width: 83%;
        }
    `}

    ${({layout}) => layout === JACKPOT_WIDGET_LAYOUT.LANDSCAPE_WIDE && css`
        width: 25%;
        padding-left: 1rem;
    `}
`;